import { SimulationActivity } from "../../models/simulation";

export class SimulationGraphs {
    
    /* 
    Actual Fields in the old simulation module:
        E-time (hr) (also: Runtime (hr))
        Depth (ft)

        E-time (hr)
        Pumped (BBLs)

        E-time (hr)
        Flowback (BBLs)
    */
    static buildBasicOptions(serie1Name: string, serie2Name: string, label_x: string, label_y: string, header:string) : any {
        return {width: 'auto', labels: [serie1Name,serie2Name], xlabel: label_x, ylabel: label_y, title: header, animatedZooms: true, pointSize: 4};
    }
    
    /* Assumes that the fields have been recalculated */
    static async buildGraphData(activities: SimulationActivity[] = [], mappingFun: (a: SimulationActivity) => [number, number]) : Promise<[number, number][]> {
        return activities.map(mappingFun);
    }

    static async buildDepthGraphData(activities: SimulationActivity[] = []) : Promise<[number, number, number][]> {
        const graphData: [number, number, number][] = []; // [RelativeTime, Depth, RE#]
        for (const activity of activities) {
            if(activity.activity === 'Short Trip') {
                const stepRelTime = (activity.calcRelativeTime ?? 0) - ((activity.duration ?? 0) / 2);
                graphData.push([stepRelTime, (activity.calcDepth ?? 0) - (activity.depthStart ?? 0), activity.calcRe ?? 0]);
                graphData.push([activity.calcRelativeTime ?? 0, activity.calcDepth ?? 0, activity.calcRe ?? 0]);
            }
            else {
                if(activity.duration && activity.depthStart && activity.isDepthStart) {
                    graphData.push([(activity.calcRelativeTime ?? 0) - activity.duration, activity.depthStart, activity.calcRe ?? 0]);
                }
                graphData.push([activity.calcRelativeTime ?? 0, activity.calcDepth ?? 0, activity.calcRe ?? 0]);
            }
        }
        return graphData;
    }

    static avDataMapping(activity: SimulationActivity) : [number, number] {
        return [activity.calcRelativeTime ?? 0, activity.calcAv ?? 0];
    }

    static flowbackBblsDataMapping(activity: SimulationActivity) : [number, number] {
        return [activity.calcRelativeTime ?? 0, activity.calcFlowbackBbls ?? 0];
    }

    static pumpedBblsDataMapping(activity: SimulationActivity) : [number, number] {
        return [activity.calcRelativeTime ?? 0, activity.calcPumpedBbls ?? 0];
    }
}
